import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminShopKeys } from 'store/admin-shop';
import { loaders } from './admin-shop-tax-exemption.loaders';

export const useCreateTaxExemption = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createTaxExemption, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminShopKeys.all);
    },
  });
};

export const useUpdateTaxExemption = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateTaxExemption, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminShopKeys.all);
    },
  });
};

export const useDeleteTaxExemption = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteTaxExemption, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminShopKeys.lists);
    },
  });
};

export const useBulkUpdateTaxExemption = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkUpdateTaxExemption, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminShopKeys.all);
    },
  });
};
